import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const getUserById = createAsyncThunk(
  "otherUser/getUsersById",
  async (userId, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue("Geçersiz kullanıcı ID'si!");
    }
    try {
      const response = await api.get(`/users/${userId}`, {});
      if (!response.data || Object.keys(response.data).length === 0) {
        throw new Error("Kullanıcı verisi bulunamadı");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Kullanıcı bilgisi alınamadı."
      );
    }
  }
);
